"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicRangeValidator = exports.DynamicRangeTemplateSchemas = exports.DynamicRangeCatalogSchemas = exports.IPEXRangeFormatCatalogSchemas = void 0;
var ipex_range_format_json_1 = __importDefault(require("./ipex-range-format.json"));
var ipex_range_format_catalog_json_1 = __importDefault(require("./ipex-range-format-catalog.json"));
var catalog_file_json_1 = __importDefault(require("./catalog-file.json"));
var catalog_item_json_1 = __importDefault(require("./catalog-item.json"));
var templates_file_json_1 = __importDefault(require("./templates-file.json"));
var template_item_json_1 = __importDefault(require("./template-item.json"));
var template_defs_json_1 = __importDefault(require("./template-defs.json"));
var template_box_json_1 = __importDefault(require("./template-box.json"));
var template_bound_json_1 = __importDefault(require("./template-bound.json"));
var template_connector_json_1 = __importDefault(require("./template-connector.json"));
var template_product_structure_json_1 = __importDefault(require("./template-product-structure.json"));
var DynamicRangeValidator_1 = __importDefault(require("./DynamicRangeValidator"));
exports.DynamicRangeValidator = DynamicRangeValidator_1.default;
var IPEXRangeFormatCatalogSchemas = {
    mainSchema: ipex_range_format_catalog_json_1.default,
    dependencies: [
        template_bound_json_1.default,
        template_box_json_1.default,
        template_connector_json_1.default,
        template_defs_json_1.default,
        template_product_structure_json_1.default,
        ipex_range_format_json_1.default
    ]
};
exports.IPEXRangeFormatCatalogSchemas = IPEXRangeFormatCatalogSchemas;
var DynamicRangeCatalogSchemas = {
    mainSchema: catalog_file_json_1.default,
    dependencies: [catalog_item_json_1.default]
};
exports.DynamicRangeCatalogSchemas = DynamicRangeCatalogSchemas;
var DynamicRangeTemplateSchemas = {
    mainSchema: templates_file_json_1.default,
    dependencies: [
        template_bound_json_1.default,
        template_box_json_1.default,
        template_connector_json_1.default,
        template_defs_json_1.default,
        template_product_structure_json_1.default,
        template_item_json_1.default
    ]
};
exports.DynamicRangeTemplateSchemas = DynamicRangeTemplateSchemas;
//# sourceMappingURL=index.js.map